module.exports = __webpack_public_path__ + "images/category_lp/art_work/new/store_images/2_83f816c96dc8f0ce87926cd28c71d9b0.png";